module.exports = __webpack_public_path__ + "img/minus_btn.c76e272a.png";